const uuid_regex =
  "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

export const projectFolderNestedPath = [
  "/casting/projects",
  `/casting/:id(${uuid_regex})/:section(shortlists|media|shared-media)?`,
];

export const breakdownCreateNestedPath = [
  `/casting/:id(${uuid_regex})/breakdowns/create`,
];
